import styled from "styled-components"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #e9e2db;
  font-family: 'Roboto', sans-serif;
  overflow-x: hidden;

  .header {
    padding: 1rem 2rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .logo-container {
      display: flex;
      align-items: center;
      gap: 3rem;
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      
      .logo {
        width: 180px;
        height: auto;
      }
      
      .nav-links {
        display: flex;
        gap: 2rem;
        
        a {
          color: #212121;
          text-decoration: none;
          font-size: 1rem;
          font-weight: 500;
          
          &:hover {
            color: #ff5101;
          }
        }
      }
    }
  }

  .hero-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    
    .hero-content {
      flex: 1;
      max-width: 500px;
      z-index: 2;
      
      h1 {
        font-size: 2.5rem;
        font-weight: 700;
        color: #212121;
        margin-bottom: 2rem;
        line-height: 1.2;
      }
      
      .cta-button {
        background-color: #ff5101;
        color: white;
        border: none;
        padding: 1rem 2rem;
        font-size: 1rem;
        font-weight: 700;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.3s ease;
        
        &:hover {
          background-color: #e04600;
          transform: translateY(-2px);
        }
      }
      
      .store-link {
        margin-top: 1.5rem;
        font-size: 0.9rem;
        
        a {
          color: #ff5101;
          text-decoration: underline;
        }
      }
    }
    
    .hero-image {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      z-index: 1;
      
      img {
        max-width: 100%;
        height: auto;
      }
    }
  }

  .benefits-section {
    background-color: #ff5101;
    padding: 4rem 2rem;
    color: white;
    text-align: center;
    position: relative;
    
    .benefits-content {
      max-width: 800px;
      margin: 0 auto;
      
      h2 {
        font-size: 2.2rem;
        font-weight: 700;
        margin-bottom: 2rem;
        line-height: 1.3;
      }
      
      .leaf-icon {
        width: 40px;
        height: auto;
        margin-top: 1rem;
      }
    }
  }

  .how-it-works-section {
    padding: 5rem 2rem;
    text-align: center;
    
    h2 {
      font-size: 2.2rem;
      font-weight: 700;
      color: #212121;
      margin-bottom: 3rem;
    }
    
    .steps-container {
      display: flex;
      justify-content: center;
      gap: 2rem;
      margin-bottom: 3rem;
      
      .step {
        flex: 1;
        max-width: 250px;
        display: flex;
        flex-direction: column;
        align-items: center;
        
        .step-number {
          background-color: #ff5101;
          color: white;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          margin-bottom: 1rem;
        }
        
        img {
          height: 150px;
          width: auto;
          margin-bottom: 1.5rem;
        }
        
        p {
          font-size: 0.9rem;
          line-height: 1.5;
          color: #212121;
        }
      }
    }
    
    a {
      display: inline-block;
      background-color: #469B54;
      color: white;
      padding: 1rem 2rem;
      border-radius: 4px;
      text-decoration: none;
      font-weight: 500;
      
      &:hover {
        background-color: #3a8a46;
      }
    }
  }

  .add-to-home-section {
    padding: 5rem 2rem;
    text-align: center;
    
    h2 {
      font-size: 2.2rem;
      font-weight: 700;
      color: #212121;
      margin-bottom: 3rem;
    }
    
    .steps-container {
      display: flex;
      justify-content: center;
      gap: 2rem;
      
      .step {
        flex: 1;
        max-width: 250px;
        display: flex;
        flex-direction: column;
        align-items: center;
        
        .step-number {
          background-color: #ff5101;
          color: white;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          margin-bottom: 1rem;
        }
        
        img {
          height: 150px;
          width: auto;
          margin-bottom: 1.5rem;
          border: 1px solid #ddd;
          border-radius: 8px;
        }
        
        p {
          font-size: 0.9rem;
          line-height: 1.5;
          color: #212121;
        }
      }
    }
  }

  .footer {
    background-color: #ff5101;
    padding: 3rem 2rem;
    text-align: center;
    color: white;
    
    .web-app-container {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      margin-bottom: 1.5rem;
      
      span {
        font-weight: 500;
      }
      
      .social-icons {
        display: flex;
        gap: 0.5rem;
        
        a {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 30px;
          height: 30px;
          background-color: white;
          border-radius: 50%;
          color: #ff5101;
          text-decoration: none;
          font-weight: 700;
          font-size: 0.8rem;
          
          &:hover {
            background-color: #f0f0f0;
          }
        }
      }
    }
    
    a {
      color: white;
      text-decoration: none;
      margin-bottom: 1rem;
      display: inline-block;
      
      &:hover {
        text-decoration: underline;
      }
    }
    
    p {
      font-size: 0.8rem;
      opacity: 0.8;
      margin-top: 1rem;
    }
  }

  /* Responsive styles */
  @media (max-width: 992px) {
    .hero-section {
      flex-direction: column;
      text-align: center;
      
      .hero-content {
        margin-bottom: 2rem;
        max-width: 100%;
      }
      
      .hero-image {
        justify-content: center;
      }
    }
    
    .benefits-section .benefits-content h2 {
      font-size: 1.8rem;
    }
  }

  @media (max-width: 768px) {
    .header .logo-container {
      flex-direction: column;
      gap: 1rem;
      align-items: flex-start;
      
      .nav-links {
        gap: 1rem;
      }
    }
    
    .how-it-works-section .steps-container,
    .add-to-home-section .steps-container {
      flex-direction: column;
      align-items: center;
      
      .step {
        margin-bottom: 2rem;
      }
    }
  }

  @media (max-width: 576px) {
    .header {
      padding: 1rem;
      
      .logo-container {
        .logo {
          width: 150px;
        }
        
        .nav-links {
          flex-wrap: wrap;
          font-size: 0.9rem;
        }
      }
    }
    
    .hero-section {
      padding: 1rem;
      
      .hero-content h1 {
        font-size: 2rem;
      }
      
      .hero-image img {
        max-width: 90%;
        margin: 0 auto;
      }
    }
    
    .benefits-section .benefits-content h2,
    .how-it-works-section h2,
    .add-to-home-section h2 {
      font-size: 1.5rem;
    }
  }
`

export default Container
